import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setActiveIndex as setActiveIndexAction } from '../../slices/company_slice'
import CompanyRequestTable from './CompanyRequestTable'
import CompanyTable from './CompanyTable'
import { TabPanel, Tabs } from 'components/utility/Tabs'

export function ListCompany() {
  const { activeIndex, approvedCompanies, rejectedCompanies } = useSelector((state) => state.company)
  const { requests } = useSelector((state) => state.companyRequest)
  const dispatch = useDispatch()

  const onChangeTab = (tabIndex) => {
    dispatch(setActiveIndexAction(tabIndex))
  }
  return (
    <>
      <Tabs activeIndex={activeIndex} setActiveIndex={onChangeTab}>
        <TabPanel label={`approved (${approvedCompanies.length})`}>
          <CompanyTable companies={approvedCompanies} />
        </TabPanel>
        <TabPanel label={`pending (${requests.length})`}>
          <CompanyRequestTable requests={requests} />
        </TabPanel>
        <TabPanel label={`rejected (${rejectedCompanies.length})`}>
          <CompanyTable companies={rejectedCompanies} />
        </TabPanel>
      </Tabs>
    </>
  )
}
